import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Search } from 'react-feather';

import s from './SidebarProfile.css';

import * as Constants from '../../constants/AppConstants';
import * as ChatRoles from '../../constants/Roles';

import Avatar from '../Avatar';
import * as routes from '../../constants/UiRoutes';
import User from '../User/User';

const SidebarProfile = ({ identity: { id, firstName, lastName, practiceName } }) => (
  <div className={s.sidebarProfile}>
    <Link
      className={s.userInfo}
      data-qa="sidebarProfile"
      to={routes.USER_SETTINGS}
    >
      <Avatar
        firstName={firstName}
        lastName={lastName}
        size={Constants.USER_SIZE_SMALL}
        type={ChatRoles.SENDER}
      />
      <div className={s.info}>
        <strong><User firstName={firstName} lastName={lastName} hideAvatar hideCurrentUserIndicator hideMentionName hideStatus noPad /></strong>
        <span data-qa="sidebarProfile-practiceName" title={practiceName}>{practiceName}</span>
      </div>
    </Link>
    <Link
      className={s.sidebarProfileAction}
      to={routes.BROWSE}
      data-qa="sidebarProfile-searchLink"
    >
      <Search size={24}/>
    </Link>
  </div>
);

SidebarProfile.propTypes = {
  identity: PropTypes.object.isRequired
};

export default SidebarProfile;
